(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ayd-aster-intentions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ayd-aster-intentions')) {
  customElements.define('ayd-aster-intentions', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.main = this.closest('.section-main-product');
      this.variants = JSON.parse(this.querySelector('[data-intention-variants]').textContent);
      document.addEventListener('on:variant:change', event => {
        if (!this.main?.contains(event.target)) return;
        const selected = this.variants.find(variant => String(variant.id) === String(event.detail.variant?.id));
        this.querySelectorAll('[data-intention]').forEach(panel => {
          panel.hidden = panel.dataset.intention !== selected?.stone;
        });
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ayd-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ayd-purchase')) {
 customElements.define('ayd-purchase', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const options = {signal:this.controller.signal};
   this.main = document.querySelector('.section-main-product');
   if (!this.main) return;
   this.select = this.querySelector('select[name="id"]');
   this.quantity = this.querySelector('[name="quantity"]');
   this.button = this.querySelector('[name="add"]');
   this.error = this.querySelector('.ayd-buy-error');
   this.bar = this.querySelector('.ayd-buy-mobile');
   this.fallback = this.querySelector('.ayd-buy-fallback');
   const info = this.main.querySelector('[id^="ProductInfo-"]');
   if(info) this.fallback.href = '#' + info.id;
   this.select.addEventListener('change', () => this.selectVariant(), options);
   document.addEventListener('on:variant:change', e => {
    if (!this.main.contains(e.target)) return;
    clearTimeout(this.timer);
    this.pending = false;
    const id = e.detail.variant?.id;
    if (id && Array.from(this.select.options).some(o => o.value === String(id))) this.select.value = String(id);
    this.update();
   }, options);
   this.quantity.addEventListener('change', () => {
    const q = this.main.querySelector('[name="quantity"]');
    if(q && this.quantity.checkValidity()) q.value = this.quantity.value;
   },options);
   this.main.addEventListener('change', e => {
    if(e.target.name === 'quantity') this.quantity.value = e.target.value;
   },options);
   this.querySelector('form').addEventListener('submit', e => {
    if(this.pending){e.preventDefault();return;}
    const form = this.main.querySelector('form.js-product-form');
    const add = form?.querySelector('[name="add"]');
    const id = form?.querySelector('[name="id"]');
    if(!form || !add || !id) return;
    e.preventDefault();
    if(add.disabled) return;
    if(id.value !== this.select.value){this.fail();return;}
    const q = this.main.querySelector('[name="quantity"]');
    if(q) q.value = this.quantity.value;
    this.error.hidden = true;
    form.requestSubmit(add);
   },options);
   this.errors = new MutationObserver(() => {
    this.update();
    const error = this.main.querySelector('.js-form-error:not([hidden])');
    if(error?.textContent.trim()){this.error.textContent=error.textContent;this.error.hidden=false;}
   });
   this.errors.observe(this.main,{subtree:true,childList:true,attributes:true,attributeFilter:['hidden','disabled']});
   this.observer = new IntersectionObserver(() => {
    const mainBuy=this.main.querySelector('.quantity-submit-row');
    const rect=mainBuy?.getBoundingClientRect();
    const bottom=this.getBoundingClientRect();
    this.bar.hidden=!(rect && rect.bottom < 0 && (bottom.top > innerHeight || bottom.bottom < 0));
   },{threshold:[0,1]});
   const mainBuy=this.main.querySelector('.quantity-submit-row');
   if(mainBuy)this.observer.observe(mainBuy);
   this.observer.observe(this);
   const initial=this.main.querySelector('form.js-product-form [name="id"]')?.value;
   if(initial && Array.from(this.select.options).some(o=>o.value===initial))this.select.value=initial;
   this.update();
  }
  update(){
   const o=this.select.selectedOptions[0];if(!o)return;
   this.querySelector('[data-price]').textContent=o.dataset.price;
   this.querySelector('[data-mobile-choice]').textContent=(this.dataset.single==='true'?'':o.textContent+' · ')+o.dataset.price;
   this.button.disabled=!!this.pending || o.dataset.available!=='true' || !!this.main.querySelector('form.js-product-form [name="add"]')?.disabled;
   this.button.textContent=this.pending?this.dataset.updating:(o.dataset.available==='true'?this.dataset.add:this.dataset.sold);
  }
  selectVariant(){
   const o=this.select.selectedOptions[0];
   const picker=this.main.querySelector('variant-picker');
   this.error.hidden=true;this.fallback.hidden=true;
   if(!picker){this.update();return;}
   const values=JSON.parse(o.dataset.options);
   const groups=picker.querySelectorAll('.option-selector:not(.option-selector--custom)');
   let last;
   for(let i=0;i<values.length;i++){
    const input=Array.from(groups[i]?.querySelectorAll('input[type="radio"]') || []).find(x=>x.value===values[i]);
    if(!input){this.fail();return;}
    input.checked=true;last=input;
   }
   this.pending=true;this.update();
   picker.dispatchEvent(new CustomEvent('change',{bubbles:true,detail:{variantId:o.value,noFocus:true}}));
   clearTimeout(this.timer);this.timer=setTimeout(()=>this.fail(),10000);
  }
  fail(){this.pending=false;this.update();this.error.textContent=this.dataset.error;this.error.hidden=false;this.fallback.hidden=false;}
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.errors?.disconnect();clearTimeout(this.timer);}
 });
}
  } catch(e) { console.error(e); }
})();

})();
